import React, { useState } from 'react';
import { useApi } from './hooks/useAPI.js';
import RaceSelector from './components/RaceSelector.jsx';
import GridSetup from './components/GridSetup.jsx';
import LightsOutAnimation from './components/LightsOutAnimation.jsx';
import ResultsPage from './components/ResultsPage.jsx';
import './index.css';

// Our app's "state machine" steps
const APP_STEPS = {
  SELECT_RACE: 'SELECT_RACE',
  SET_GRID: 'SET_GRID',
  SHOW_LIGHTS: 'SHOW_LIGHTS',
  SHOW_RESULTS: 'SHOW_RESULTS',
};

function App() {
  const [raceInfo, setRaceInfo] = useState(null);
  const [predictionData, setPredictionData] = useState(null);
  const [currentStep, setCurrentStep] = useState(APP_STEPS.SELECT_RACE);

  // API Hook for predictions (POST)
  const { 
    isLoading: predictionLoading, 
    error: predictionError, 
    postData: runPrediction 
  } = useApi();

  // --- State Handlers ---

  // 1. RaceSelector -> App
  const handleGridReady = (info) => {
    setRaceInfo(info);
    setCurrentStep(APP_STEPS.SET_GRID);
  };

  // 2. GridSetup -> App
  const handlePredict = async (finalGrid) => {
    setCurrentStep(APP_STEPS.SHOW_LIGHTS);
    const payload = {
      race_year: raceInfo.year,
      race_name: raceInfo.raceName,
      custom_grid_inputs: finalGrid,
    };
    
    const results = await runPrediction('/api/predict', payload);
    setPredictionData(results); 
  };

  // 3. LightsOutAnimation -> App
  const handleAnimationComplete = () => {
    if (predictionData || predictionError) {
      setCurrentStep(APP_STEPS.SHOW_RESULTS);
    }
  };

  // 4. ResultsPage -> App (Reset)
  const handleStartOver = () => {
    setRaceInfo(null);
    setPredictionData(null);
    setCurrentStep(APP_STEPS.SELECT_RACE);
  };

  // --- Render Logic ---

  // *** THIS IS THE CORRECTED CODE ***
  // It uses url('/h_image.jpg'), which points to the 'frontend/public' folder
  const getAppBgStyle = () => {
    if (currentStep === APP_STEPS.SELECT_RACE) {
      return {
        backgroundImage: `
          linear-gradient(to bottom, rgba(18, 18, 18, 0.5), rgba(18, 18, 18, .6)),
          url('/h_image.jpg')
        `,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
      };
    }
    // Default background for all other steps
    return {
      backgroundColor: '#fff',
      minHeight: '100vh',
    };
  };

  const renderStep = () => {
    switch (currentStep) {
      case APP_STEPS.SELECT_RACE:
        return <RaceSelector onGridReady={handleGridReady} />;
        
      case APP_STEPS.SET_GRID:
        return (
          <GridSetup 
            raceInfo={raceInfo} 
            onGridComplete={handlePredict} 
            onBack={handleStartOver}
          />
        );
        
      case APP_STEPS.SHOW_LIGHTS:
        return (
          <LightsOutAnimation 
            isLoading={predictionLoading}
            onAnimationComplete={handleAnimationComplete} 
          />
        );
        
      case APP_STEPS.SHOW_RESULTS:
        return (
          <ResultsPage 
            predictions={predictionData}
            error={predictionError}
            onStartOver={handleStartOver} 
            raceInfo={raceInfo}
          />
        );
        
      default:
        return <RaceSelector onGridReady={handleGridReady} />;
    }
  };

  return (
    // We use style here to apply the dynamic background
    <div style={getAppBgStyle()} className="text-white font-sans transition-all duration-300">
      <header className="py-4">
        <h1 className="text-3xl font-bold text-center text-f1-red tracking-wide">
          F1 Podium Predictor
        </h1>
      </header>
      <main className="p-4 md:p-8">
        {renderStep()}
      </main>
    </div>
  );
}

export default App;